import React, { useEffect, useRef, useState } from "react";
import { Loader2, AlertTriangle } from "lucide-react";
import { API } from "@/lib/constants";

/**
 * Handles the #session_id fragment returned by Emergent OAuth.
 * Exchanges it for a persistent cookie, then removes the hash and reloads the app.
 */
export default function AuthCallback({ onDone }) {
  const hasProcessed = useRef(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    const sessionId = m ? decodeURIComponent(m[1]) : "";
    if (!sessionId) {
      setError("Missing session_id in URL");
      return;
    }

    (async () => {
      try {
        const r = await fetch(`${API}/auth/session`, {
          method: "POST",
          credentials: "include",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ session_id: sessionId }),
        });
        if (!r.ok) throw new Error("Session exchange failed");
      } catch (e) {
        setError("Sign-in failed. Please try again.");
        return;
      }
      // Clear the hash and reload state
      const cleanUrl = window.location.origin + window.location.pathname + window.location.search;
      window.history.replaceState({}, "", cleanUrl);
      if (onDone) onDone();
    })();
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#FAF6F0]">
      <div className="text-center">
        {error ? (
          <div className="text-[#D9423E] flex flex-col items-center gap-3">
            <AlertTriangle className="w-8 h-8" />
            <div className="font-semibold">{error}</div>
            <a href="/" className="btn-outline mt-2 !py-2">Back home</a>
          </div>
        ) : (
          <div className="text-[#57534E] flex flex-col items-center gap-3">
            <Loader2 className="w-8 h-8 animate-spin text-[#D95D39]" />
            <div className="font-semibold">Signing you in…</div>
          </div>
        )}
      </div>
    </div>
  );
}
